<div pmdModal
	#confirmDetail="pmd-modal"
	class="modal pmd-modal fade"
	tabindex="-1"
	role="dialog"
	aria-labelledby="vertically-centered"
	(onHidden)="confirmDetailHide()">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header pb-3 border-b-1 align-items-center justify-content-between">
				<h4 class="modal-title"
					*ngIf="currentStep == 1">Confirm Below Details</h4>
				<div class="div content-hdr"
					*ngIf="currentStep == 2">
					<h4 class="modal-title">{{getRemainingFreeTrialDays()}} Days Left in Free Trial</h4>
					<p class="mb-0">Upgrade to premium plan and get access to all the premium features</p>
				</div>
				<div class="div content-hdr"
					*ngIf="currentStep == 3">
					<h4 class="modal-title">Subscription = ₹6000 + 18% GST</h4>
					<p class="mb-0">Pay using UPI | Credit or Debit Card | Net Banking</p>
				</div>
				<div class="div content-hdr"
					*ngIf="currentStep == 4">
					<h4 class="modal-title">You have been upgraded to Premium Version</h4>
					<p class="mb-0">Choose what you want to do next:</p>
				</div>
				<button aria-label="Close"
					(click)="confirmDetailHide()"
					class="close"
					type="button">
					<i class="material-icons-round">close</i>
				</button>
			</div>
			<!-- Modal Body -->
			<form action="#">
				<div class="modal-body p-0 m-0">
					<div class="personal-info-card p-3"
						*ngIf="currentStep == 1">
						<div class="mb-3">
							<label for="CompanyName"
								class="col-form-label">Company Name <strong class="text-danger">*</strong>
							</label>
							<pmd-textfield pmd-textfield-outline>
								<input name="CompanyName"
									id="CompanyName"
									maxlength="100"
									type="text"
									class="form-control"
									placeholder="ex: Rich Elements Ltd"
									pmdTextField
									autocomplete="off">
							</pmd-textfield>
						</div>
						<div class="mb-3">
							<label for="GSTNumber"
								class="col-form-label">GST Number
							</label>
							<pmd-textfield pmd-textfield-outline>
								<input name="GSTNumber"
									id="GSTNumber"
									maxlength="100"
									type="text"
									class="form-control"
									pmdTextField
									placeholder="ex: 24BMDAM9828Z3Z1"
									autocomplete="off">
							</pmd-textfield>
						</div>
						<div class="mb-3">
							<label for="PAN"
								class="col-form-label">PAN <strong class="text-danger">*</strong>
							</label>
							<pmd-textfield pmd-textfield-outline>
								<input name="PAN"
									id="PAN"
									maxlength="100"
									type="text"
									class="form-control"
									placeholder="ex: MDAM9828Z"
									pmdTextField
									autocomplete="off">
							</pmd-textfield>
						</div>
						<div class="row">
							<div class="col-md-6 mt-3">
								<label for="State"
									class="col-form-label">State <strong class="text-danger">*</strong>
								</label>
								<ng-select [searchable]="false"
									[clearable]="true"
									[items]="['Item 1', 'Item 2', 'Item 3']"
									bindLabel="name"
									bindValue="name"
									appearance="outline"
									class="pmd-select pmd-select-outline"
									placeholder="Select"
									name="searchFilter">
								</ng-select>
							</div>
							<div class="col-md-6 mt-3">
								<label for="City"
									class="col-form-label">City <strong class="text-danger">*</strong>
								</label>
								<ng-select [searchable]="false"
									[clearable]="true"
									[items]="['Item 1', 'Item 2', 'Item 3']"
									bindLabel="name"
									bindValue="name"
									appearance="outline"
									class="pmd-select pmd-select-outline"
									placeholder="Select"
									name="searchFilter">
								</ng-select>
							</div>
						</div>
					</div>
					<div class="personal-info-card"
						*ngIf="currentStep == 2">
						<pmd-card class="table_border box-shadow-none rounded-0 mb-0">
							<table class="table pmd-table table-align-middle">
								<thead>
									<tr>
										<th>
											Features
										</th>
										<th>
											Paid
										</th>
										<th class="pe-3">
											Free
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td data-title="Features">
											<div class="d-flex align-items-center gap-3 ">
												<div class="img-circle-feature">
													<svg width="23"
														height="23"
														viewBox="0 0 23 23"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M17.317 7.75977C22.0945 7.75977 22.0945 15.2598 17.317 15.2598C12.5405 15.2598 10.6298 7.75977 5.37422 7.75977C1.07578 7.75977 1.07578 15.2598 5.37422 15.2598C10.6298 15.2598 12.5405 7.75977 17.318 7.75977H17.317Z"
															stroke="#E6B401"
															stroke-width="1.6"
															stroke-linecap="round"
															stroke-linejoin="round" />
													</svg>
												</div>
												<div class="contetn">
													<h6 class="text-dark">Unlimited Invoice Uploads</h6>
													<p class="text-desc mb-0">Upload unlimited invoices directly from
														your
														phone
														or web</p>
												</div>
											</div>
										</td>
										<td data-title="Paid">
											<span class="material-symbols-outlined text-success">
												check
											</span>
										</td>
										<td data-title="Free">
											<span class="material-symbols-outlined text-desc">
												close
											</span>
										</td>
									</tr>
									<tr>
										<td data-title="Features">
											<div class="d-flex align-items-center gap-3 ">
												<div class="img-circle-feature">
													<svg width="19"
														height="19"
														viewBox="0 0 19 19"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M2.96289 6.49764V13.9976M7.18164 6.49764V13.9976M11.8691 6.49764V13.9976M16.0879 6.49764V13.9976M1.08789 15.4976L1.08789 16.2476C1.08789 16.7727 1.08789 17.0352 1.19007 17.2358C1.27995 17.4122 1.42337 17.5556 1.59977 17.6455C1.80032 17.7476 2.06284 17.7476 2.58789 17.7476H16.4629C16.9879 17.7476 17.2505 17.7476 17.451 17.6455C17.6274 17.5556 17.7708 17.4122 17.8607 17.2358C17.9629 17.0352 17.9629 16.7727 17.9629 16.2476V15.4976C17.9629 14.9726 17.9629 14.7101 17.8607 14.5095C17.7708 14.3331 17.6274 14.1897 17.451 14.0998C17.2505 13.9976 16.9879 13.9976 16.4629 13.9976H2.58789C2.06284 13.9976 1.80032 13.9976 1.59977 14.0998C1.42337 14.1897 1.27995 14.3331 1.19007 14.5095C1.08789 14.7101 1.08789 14.9726 1.08789 15.4976ZM9.19999 0.944949L2.2625 2.48661C1.84338 2.57975 1.63382 2.62632 1.47739 2.73902C1.33941 2.83842 1.23107 2.97348 1.16397 3.12973C1.08789 3.30688 1.08789 3.52155 1.08789 3.9509L1.08789 4.99764C1.08789 5.52269 1.08789 5.78521 1.19007 5.98575C1.27995 6.16216 1.42337 6.30557 1.59977 6.39546C1.80032 6.49764 2.06284 6.49764 2.58789 6.49764H16.4629C16.9879 6.49764 17.2505 6.49764 17.451 6.39546C17.6274 6.30557 17.7708 6.16216 17.8607 5.98575C17.9629 5.78521 17.9629 5.52269 17.9629 4.99764V3.9509C17.9629 3.52155 17.9629 3.30688 17.8868 3.12973C17.8197 2.97348 17.7114 2.83842 17.5734 2.73902C17.417 2.62632 17.2074 2.57975 16.7883 2.48662L9.85079 0.944949C9.72936 0.917964 9.66864 0.904472 9.60729 0.899092C9.55279 0.894313 9.49799 0.894313 9.44349 0.899092C9.38214 0.904472 9.32143 0.917964 9.19999 0.944949Z"
															stroke="#E6B401"
															stroke-width="1.4"
															stroke-linecap="round"
															stroke-linejoin="round" />
													</svg>
												</div>
												<div class="contetn">
													<h6 class="text-dark">Banking & Payments</h6>
													<p class="text-desc mb-0">Seamless vendor payout process without
														hassles
													</p>
												</div>
											</div>
										</td>
										<td data-title="Paid">
											<span class="material-symbols-outlined text-success">
												check
											</span>
										</td>
										<td data-title="Free">
											<span class="material-symbols-outlined text-desc">
												close
											</span>
										</td>
									</tr>
									<tr>
										<td data-title="Features">
											<div class="d-flex align-items-center gap-3 ">
												<div class="img-circle-feature">
													<svg width="23"
														height="24"
														viewBox="0 0 23 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M7.30664 5.07812C7.30664 3.78371 8.35597 2.73438 9.65039 2.73438C10.9448 2.73438 11.9941 3.78371 11.9941 5.07812V6.48438H12.9316C14.2421 6.48438 14.8973 6.48437 15.4142 6.69846C16.1033 6.98392 16.6509 7.53144 16.9363 8.22058C17.1504 8.73743 17.1504 9.39266 17.1504 10.7031H18.5566C19.8511 10.7031 20.9004 11.7525 20.9004 13.0469C20.9004 14.3413 19.8511 15.3906 18.5566 15.3906H17.1504V16.9844C17.1504 18.5595 17.1504 19.3471 16.8438 19.9487C16.5742 20.4779 16.1439 20.9082 15.6147 21.1778C15.0131 21.4844 14.2255 21.4844 12.6504 21.4844H11.9941V19.8438C11.9941 18.6788 11.0497 17.7344 9.88477 17.7344C8.71979 17.7344 7.77539 18.6788 7.77539 19.8438V21.4844H6.65039C5.07524 21.4844 4.28767 21.4844 3.68604 21.1778C3.15684 20.9082 2.72658 20.4779 2.45693 19.9487C2.15039 19.3471 2.15039 18.5595 2.15039 16.9844V15.3906H3.55664C4.85106 15.3906 5.90039 14.3413 5.90039 13.0469C5.90039 11.7525 4.85106 10.7031 3.55664 10.7031H2.15039C2.15039 9.39266 2.15039 8.73743 2.36448 8.22058C2.64993 7.53144 3.19745 6.98392 3.88659 6.69846C4.40345 6.48437 5.05868 6.48438 6.36914 6.48438H7.30664V5.07812Z"
															stroke="#E6B401"
															stroke-width="1.5"
															stroke-linecap="round"
															stroke-linejoin="round" />
													</svg>
												</div>
												<div class="contetn">
													<h6 class="text-dark">Marketplace/Integrations</h6>
													<p class="text-desc mb-0">Connect with multiple software with simple
														clicks
													</p>
												</div>
											</div>
										</td>
										<td data-title="Paid">
											<span class="material-symbols-outlined text-success">
												check
											</span>
										</td>
										<td data-title="Free">
											<span class="material-symbols-outlined text-desc">
												close
											</span>
										</td>
									</tr>
									<tr>
										<td data-title="Features">
											<div class="d-flex align-items-center gap-3 ">
												<div class="img-circle-feature">
													<svg width="23"
														height="24"
														viewBox="0 0 23 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M7.30664 10.9727H4.58789C4.06284 10.9727 3.80032 10.9727 3.59977 11.0748C3.42337 11.1647 3.27995 11.3081 3.19007 11.4845C3.08789 11.6851 3.08789 11.9476 3.08789 12.4727V20.3477M15.7441 10.9727H18.4629C18.9879 10.9727 19.2505 10.9727 19.451 11.0748C19.6274 11.1647 19.7708 11.3081 19.8607 11.4845C19.9629 11.6851 19.9629 11.9476 19.9629 12.4727V20.3477M15.7441 20.3477V6.47266C15.7441 5.42256 15.7441 4.89751 15.5398 4.49642C15.36 4.14362 15.0732 3.85678 14.7204 3.67702C14.3193 3.47266 13.7942 3.47266 12.7441 3.47266H10.3066C9.25654 3.47266 8.73149 3.47266 8.33041 3.67702C7.9776 3.85678 7.69077 4.14362 7.511 4.49642C7.30664 4.89751 7.30664 5.42256 7.30664 6.47266V20.3477M20.9004 20.3477H2.15039M10.5879 7.22266H12.4629M10.5879 10.9727H12.4629M10.5879 14.7227H12.4629"
															stroke="#E6B401"
															stroke-width="1.5"
															stroke-linecap="round"
															stroke-linejoin="round" />
													</svg>
												</div>
												<div class="contetn">
													<h6 class="text-dark">Multiple Company & Entities</h6>
													<p class="text-desc mb-0">Create multiple admins and users to divide
														the
														work
													</p>
												</div>
											</div>
										</td>
										<td data-title="Paid">
											<span class="material-symbols-outlined text-success">
												check
											</span>
										</td>
										<td data-title="Free">
											<span class="material-symbols-outlined text-desc">
												close
											</span>
										</td>
									</tr>
									<tr>
										<td data-title="Features">
											<div class="d-flex align-items-center gap-3 ">
												<div class="img-circle-feature">
													<svg width="23"
														height="23"
														viewBox="0 0 23 23"
														fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M18.0879 20.1484V14.5234M15.2754 17.3359H20.9004M11.5254 14.5234H7.77539C6.02811 14.5234 5.15447 14.5234 4.46533 14.8089C3.54647 15.1895 2.81644 15.9195 2.43584 16.8384C2.15039 17.5275 2.15039 18.4012 2.15039 20.1484M14.8066 3.54602C16.1809 4.10232 17.1504 5.44967 17.1504 7.02344C17.1504 8.59721 16.1809 9.94455 14.8066 10.5009M12.9316 7.02344C12.9316 9.09451 11.2527 10.7734 9.18164 10.7734C7.11057 10.7734 5.43164 9.09451 5.43164 7.02344C5.43164 4.95237 7.11057 3.27344 9.18164 3.27344C11.2527 3.27344 12.9316 4.95237 12.9316 7.02344Z"
															stroke="#E6B401"
															stroke-width="1.5"
															stroke-linecap="round"
															stroke-linejoin="round" />
													</svg>
												</div>
												<div class="contetn">
													<h6 class="text-dark">Multiple Users & Admins</h6>
													<p class="text-desc mb-0">Create multiple admins and users to divide
														the
														work
													</p>
												</div>
											</div>
										</td>
										<td data-title="Paid">
											<span class="material-symbols-outlined text-success">
												check
											</span>
										</td>
										<td data-title="Free">
											<span class="material-symbols-outlined text-desc">
												close
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</pmd-card>
					</div>
					<div class="personal-info-card p-3"
						*ngIf="currentStep == 3">
						<div class="QR-generator-section">
							<div class="d-flex flex-column align-items-center gap-3 py-3">
								<img src="assets/images/qr-scan.png"
									alt="qr-scan.png">
								<p>Pay using any UPI enabled app</p>
							</div>
							<div class="upi-action-buttons">
								<a href="#"><img src="assets/images/phone-pe.svg"
										alt="phone-pe"></a>
								<a href="#"><img src="assets/images/paytm.svg"
										alt="paytm.svg"></a>
								<a href="#"><img src="assets/images/google-pay.svg"
										alt="google-pay.svg"></a>
								<a href="#"><img src="assets/images/upi.svg"
										alt="upi.svg"></a>
							</div>
						</div>
						<p class="text-center mt-3">Complete Transaction in 9:10</p>
					</div>
					<div class="personal-info-card p-3"
						*ngIf="currentStep == 4">
						<div class="row text-center">
							<div class="col-md-6">
								<pmd-card class="p-4">
									<div class="card-list-circle">
										<div class="rounded-img">
											<svg width="24"
												height="23"
												viewBox="0 0 24 23"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M11.875 16.7656H11.8844M8.3125 20.9844H15.4375C16.4876 20.9844 17.0126 20.9844 17.4137 20.78C17.7665 20.6002 18.0534 20.3134 18.2331 19.9606C18.4375 19.5595 18.4375 19.0345 18.4375 17.9844V5.23437C18.4375 4.18428 18.4375 3.65923 18.2331 3.25814C18.0534 2.90534 17.7665 2.6185 17.4137 2.43874C17.0126 2.23438 16.4876 2.23438 15.4375 2.23438H8.3125C7.2624 2.23438 6.73735 2.23438 6.33627 2.43874C5.98346 2.6185 5.69663 2.90534 5.51686 3.25814C5.3125 3.65923 5.3125 4.18428 5.3125 5.23438V17.9844C5.3125 19.0345 5.3125 19.5595 5.51686 19.9606C5.69663 20.3134 5.98346 20.6002 6.33627 20.78C6.73735 20.9844 7.2624 20.9844 8.3125 20.9844ZM12.3438 16.7656C12.3438 17.0245 12.1339 17.2344 11.875 17.2344C11.6161 17.2344 11.4062 17.0245 11.4062 16.7656C11.4062 16.5067 11.6161 16.2969 11.875 16.2969C12.1339 16.2969 12.3438 16.5067 12.3438 16.7656Z"
													stroke="#E6B401"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
										</div>
										<p class="fw-semibold mb-0">Upload Invoices Via App
										</p>
										<div class="text-desc">
											Capture invoices directly from your phone
										</div>
									</div>
								</pmd-card>
							</div>
							<div class="col-md-6">
								<pmd-card class="p-4">
									<div class="card-list-circle">
										<div class="rounded-img">
											<svg width="23"
												height="23"
												viewBox="0 0 23 23"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M7.15625 4.57812C7.15625 3.28371 8.20558 2.23438 9.5 2.23438C10.7944 2.23438 11.8438 3.28371 11.8438 4.57812V5.98438H12.7812C14.0917 5.98438 14.7469 5.98437 15.2638 6.19846C15.9529 6.48392 16.5005 7.03144 16.7859 7.72058C17 8.23743 17 8.89266 17 10.2031H18.4062C19.7007 10.2031 20.75 11.2525 20.75 12.5469C20.75 13.8413 19.7007 14.8906 18.4062 14.8906H17V16.4844C17 18.0595 17 18.8471 16.6935 19.4487C16.4238 19.9779 15.9936 20.4082 15.4643 20.6778C14.8627 20.9844 14.0751 20.9844 12.5 20.9844H11.8438V19.3438C11.8438 18.1788 10.8994 17.2344 9.73438 17.2344C8.5694 17.2344 7.625 18.1788 7.625 19.3438V20.9844H6.5C4.92485 20.9844 4.13728 20.9844 3.53565 20.6778C3.00645 20.4082 2.57619 19.9779 2.30654 19.4487C2 18.8471 2 18.0595 2 16.4844V14.8906H3.40625C4.70067 14.8906 5.75 13.8413 5.75 12.5469C5.75 11.2525 4.70067 10.2031 3.40625 10.2031H2C2 8.89266 2 8.23743 2.21409 7.72058C2.49954 7.03144 3.04706 6.48392 3.7362 6.19846C4.25306 5.98437 4.90829 5.98438 6.21875 5.98438H7.15625V4.57812Z"
													stroke="#E6B401"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
										</div>
										<p class="fw-semibold mb-0">Explore Integrations</p>
										<div class="text-desc">
											Connect with multiple software with simple clicks
										</div>
									</div>
								</pmd-card>
							</div>
							<div class="col-md-6">
								<pmd-card class="p-4">
									<div class="card-list-circle">
										<div class="rounded-img">
											<svg width="24"
												height="23"
												viewBox="0 0 24 23"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M5.3125 8.79647V16.2965M9.53125 8.79647V16.2965M14.2188 8.79647V16.2965M18.4375 8.79647V16.2965M3.4375 17.7965L3.4375 18.5465C3.4375 19.0715 3.4375 19.334 3.53968 19.5346C3.62956 19.711 3.77298 19.8544 3.94938 19.9443C4.14993 20.0465 4.41245 20.0465 4.9375 20.0465H18.8125C19.3375 20.0465 19.6001 20.0465 19.8006 19.9443C19.977 19.8544 20.1204 19.711 20.2103 19.5346C20.3125 19.334 20.3125 19.0715 20.3125 18.5465V17.7965C20.3125 17.2714 20.3125 17.0089 20.2103 16.8084C20.1204 16.6319 19.977 16.4885 19.8006 16.3986C19.6001 16.2965 19.3375 16.2965 18.8125 16.2965H4.9375C4.41245 16.2965 4.14993 16.2965 3.94938 16.3986C3.77298 16.4885 3.62956 16.6319 3.53968 16.8083C3.4375 17.0089 3.4375 17.2714 3.4375 17.7965ZM11.5496 3.24378L4.6121 4.78544C4.19298 4.87858 3.98343 4.92515 3.827 5.03784C3.68902 5.13725 3.58068 5.27231 3.51358 5.42856C3.4375 5.60571 3.4375 5.82038 3.4375 6.24972L3.4375 7.29647C3.4375 7.82151 3.4375 8.08404 3.53968 8.28458C3.62956 8.46098 3.77298 8.6044 3.94938 8.69428C4.14993 8.79647 4.41245 8.79647 4.9375 8.79647H18.8125C19.3375 8.79647 19.6001 8.79647 19.8006 8.69428C19.977 8.6044 20.1204 8.46098 20.2103 8.28458C20.3125 8.08404 20.3125 7.82152 20.3125 7.29647V6.24972C20.3125 5.82038 20.3125 5.60571 20.2364 5.42856C20.1693 5.27231 20.061 5.13725 19.923 5.03785C19.7666 4.92515 19.557 4.87858 19.1379 4.78544L12.2004 3.24378C12.079 3.21679 12.0182 3.2033 11.9569 3.19792C11.9024 3.19314 11.8476 3.19314 11.7931 3.19792C11.7317 3.2033 11.671 3.21679 11.5496 3.24378Z"
													stroke="#E6B401"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
										</div>
										<p class="fw-semibold mb-0">Enable Banking & Payments</p>
										<div class="text-desc">
											Seamless vendor payout process without hassles
										</div>
									</div>
								</pmd-card>
							</div>
							<div class="col-md-6">
								<pmd-card class="p-4">
									<div class="card-list-circle">
										<div class="rounded-img">
											<svg width="24"
												height="23"
												viewBox="0 0 24 23"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M5.3125 8.79647V16.2965M9.53125 8.79647V16.2965M14.2188 8.79647V16.2965M18.4375 8.79647V16.2965M3.4375 17.7965L3.4375 18.5465C3.4375 19.0715 3.4375 19.334 3.53968 19.5346C3.62956 19.711 3.77298 19.8544 3.94938 19.9443C4.14993 20.0465 4.41245 20.0465 4.9375 20.0465H18.8125C19.3375 20.0465 19.6001 20.0465 19.8006 19.9443C19.977 19.8544 20.1204 19.711 20.2103 19.5346C20.3125 19.334 20.3125 19.0715 20.3125 18.5465V17.7965C20.3125 17.2714 20.3125 17.0089 20.2103 16.8084C20.1204 16.6319 19.977 16.4885 19.8006 16.3986C19.6001 16.2965 19.3375 16.2965 18.8125 16.2965H4.9375C4.41245 16.2965 4.14993 16.2965 3.94938 16.3986C3.77298 16.4885 3.62956 16.6319 3.53968 16.8083C3.4375 17.0089 3.4375 17.2714 3.4375 17.7965ZM11.5496 3.24378L4.6121 4.78544C4.19298 4.87858 3.98343 4.92515 3.827 5.03784C3.68902 5.13725 3.58068 5.27231 3.51358 5.42856C3.4375 5.60571 3.4375 5.82038 3.4375 6.24972L3.4375 7.29647C3.4375 7.82151 3.4375 8.08404 3.53968 8.28458C3.62956 8.46098 3.77298 8.6044 3.94938 8.69428C4.14993 8.79647 4.41245 8.79647 4.9375 8.79647H18.8125C19.3375 8.79647 19.6001 8.79647 19.8006 8.69428C19.977 8.6044 20.1204 8.46098 20.2103 8.28458C20.3125 8.08404 20.3125 7.82152 20.3125 7.29647V6.24972C20.3125 5.82038 20.3125 5.60571 20.2364 5.42856C20.1693 5.27231 20.061 5.13725 19.923 5.03785C19.7666 4.92515 19.557 4.87858 19.1379 4.78544L12.2004 3.24378C12.079 3.21679 12.0182 3.2033 11.9569 3.19792C11.9024 3.19314 11.8476 3.19314 11.7931 3.19792C11.7317 3.2033 11.671 3.21679 11.5496 3.24378Z"
													stroke="#E6B401"
													stroke-width="1.5"
													stroke-linecap="round"
													stroke-linejoin="round" />
											</svg>
										</div>
										<p class="fw-semibold mb-0">Create Users or Admins</p>
										<div class="text-desc">
											Create multiple admins and users to divide the work
										</div>
									</div>
								</pmd-card>
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer gap-2 align-items-center"
					[ngClass]="currentStep == 4 ? 'justify-content-between':'justify-content-end'">
					<div class="d-flex gap-2">
						<button type="button"
							pmdRipple
							pmd-btn-outline
							class="pmd-btn-min"
							color="dark"
							*ngIf="currentStep == 4"
							(click)="goToBackStep()">
							Download
						</button>
						<button type="button"
							pmdRipple
							*ngIf="currentStep == 1 || currentStep == 4"
							pmd-btn-outline
							class="pmd-btn-min"
							color="dark"
							(click)="confirmDetailHide()">
							{{ currentStep == 1 ? 'Cancel' : 'Skip For Now' }}
						</button>
					</div>
					<!-- <button type="button"
						pmdRipple
						pmd-btn-outline
						class="pmd-btn-min"
						color="dark"
						*ngIf="currentStep == 2"
						(click)="goToBackStep()">
						Back
					</button> -->
					<button type="button"
						*ngIf="currentStep == 1 || currentStep == 2 || currentStep == 4"
						pmdRipple
						pmd-btn-raised
						class="pmd-btn-min"
						(click)="goToNextStep()"
						color="secondary">
						{{ currentStep == 1 || currentStep == 4 ? 'Continue':'Request Call Back'}}
					</button>
					<button type="button"
						*ngIf="currentStep == 3"
						pmdRipple
						pmd-btn-raised
						class="w-100"
						(click)="goToNextStep()"
						color="secondary">
						Credit & Debit cards or Net Banking
					</button>
				</div>
			</form>
		</div>
	</div>
</div>